export const colors = {
  primary: '#ea5b0c',
  primaryHover: '#c64c09',
  secondary: '#013460',
  secondaryHover: '#022b4e',
  white: '#ffffff',
  black: 'rgba(0, 0, 0, 0.8)',
  grayDark: '#686767',
  grayMedium: '#9B9B9B',
  gray: '#DEDEDE',
  grayLight: '#F2F2F2',
  grayBg: '#FAFAFA',
  filterBg: '#F2F2F2',
  filterBorder: 'rgba(0, 0, 0, 0.49)',
  accentOne: '#1BA029',
  accentTwo: '#FBBA00',
  accentThree: '#CD0000',
  footerBg: 'rgba(0, 0, 0, 0.8)',
  stickyBg: '#353535',
  dataLayer: '#8f9fb5',
  error: '#CD0000'
};
